import { useState, useEffect } from "react";

interface NavProps {
  brand: string;
}

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Approach", href: "#approach" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
] as const;

export function Nav({ brand }: NavProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const el = document.querySelector("[data-site-scroll]");
    if (!el) return;
    const onScroll = () => setScrolled(el.scrollTop > 8);
    onScroll();
    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 20,
        borderBottom: "1px solid " + (scrolled ? "var(--hairline)" : "transparent"),
        background: scrolled ? "color-mix(in oklab, var(--paper) 78%, transparent)" : "transparent",
        backdropFilter: scrolled ? "blur(20px) saturate(140%)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(20px) saturate(140%)" : "none",
        transition:
          "background var(--dur-base) var(--ease-out), border-color var(--dur-base) var(--ease-out)",
      }}
    >
      <div
        className="container nav-bar"
        style={{ padding: "18px 32px", display: "flex", alignItems: "center", gap: 32 }}
      >
        <a
          href="#top"
          className="chrome"
          style={{ display: "flex", alignItems: "center", gap: 10, color: "var(--ink)" }}
        >
          <svg width="22" height="22" viewBox="0 0 64 64" fill="none" aria-hidden>
            <rect x="6" y="17.5" width="52" height="29" rx="14.5" stroke="currentColor" strokeWidth="2.4" />
            <rect x="16.5" y="30.4" width="24" height="3.2" rx="1.6" fill="currentColor" />
            <circle cx="45" cy="32" r="2.8" fill="var(--beam)" />
          </svg>
          <span
            style={{
              fontFamily: "var(--font-display)",
              fontWeight: 500,
              fontSize: 16,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
            }}
          >
            {brand}
          </span>
        </a>

        <nav className="nav-links" style={{ display: "flex", gap: 2, marginLeft: 16 }}>
          {LINKS.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              className="chrome"
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 500,
                fontSize: 13,
                color: "var(--ink-3)",
                padding: "8px 14px",
                borderRadius: "var(--r-md)",
                transition:
                  "color var(--dur-fast) var(--ease-out), background var(--dur-fast) var(--ease-out)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "var(--ink)";
                e.currentTarget.style.background = "var(--paper-soft)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "var(--ink-3)";
                e.currentTarget.style.background = "transparent";
              }}
            >
              {label}
            </a>
          ))}
        </nav>

        <div style={{ flex: 1 }} />

        <a href="#contact" className="btn btn-primary" style={{ padding: "9px 16px" }}>
          Get in touch
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </a>
      </div>
    </header>
  );
}
